import {withStyles} from '@material-ui/core/styles';
import {Rating} from '@material-ui/lab';
import {PRIMARY_RED} from '../../../const/colors';

const CustomRating = withStyles({
    iconFilled: {
        color: PRIMARY_RED,
    },
})(Rating);

export default CustomRating;
